import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PageResponse } from '@core/shared/domain';

import { PlattformPackungseinheit } from './industriekatalog';

@Injectable({ providedIn: 'root' })
export class PackungseinheitenService {
  private readonly baseApiPath = '/api/contentmanagement/platformpackagingunits';

  constructor(private readonly httpClient: HttpClient) {}

  getAll(params?: HttpParams): Observable<PageResponse<PlattformPackungseinheit>> {
    return this.httpClient.get<PageResponse<PlattformPackungseinheit>>(`${this.baseApiPath}`, { params });
  }
}
